import { useMutation, useQueryClient } from '@tanstack/react-query'

import { ErrorResponse } from '@sparkai/utils'

import { apiClient } from '../../../apiClient'
import { USE_GET_PROGRAM_ONTOLOGY_KEY } from '../useGetCurrentProgramOntologyConfig'
import { OntologyPredictionCorrection } from './ontologyPredictionCorrectionTypings'
import { USE_ONTOLOGY_PREDICTION_CORRECTION_BY_ID_KEY } from './useGetOntologyPredictionCorrectionById'

type CreateOntologyPredictionCorrectionPayload = Omit<
  OntologyPredictionCorrection,
  'instances' | 'predictionCorrectionId' | 'programId' | 'criticalErrorDefinitionCount'
>

export function useCreateOntologyPredictionCorrection(programId?: string, onSuccess?: () => void) {
  const queryClient = useQueryClient()

  return useMutation<unknown, ErrorResponse, CreateOntologyPredictionCorrectionPayload>({
    mutationFn: async (values: CreateOntologyPredictionCorrectionPayload) => {
      const { data } = await apiClient.post(
        `/int/v3/programs/${programId}/ontology/prediction-corrections`,
        values
      )
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USE_GET_PROGRAM_ONTOLOGY_KEY] })
      queryClient.invalidateQueries({ queryKey: [USE_ONTOLOGY_PREDICTION_CORRECTION_BY_ID_KEY] })

      onSuccess?.()
    },
  })
}
